/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {databaseFactory as ɵa} from './src/module';